import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import "./DatatableV1.css";
import * as XLSX from "xlsx";
import { CircleX, Download, FilterX } from 'lucide-react';
import { ChevronUp, ChevronDown, Search, ChevronsLeft, ChevronsRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { RoleFilterComponent, PatientStatusFilterComponent, PracticeFilterComponent, DivisionFilterComponent, SmsDateFilterComponent, ActiveInactiveFilterComponent, MessageTemplate, WhatsAppCheck, CommunicationChannel } from "./CustomFilterComponent";

const DataTable = ({
    columns,
    data,
    totalRows,
    title,
    loading,
    onPageChange,
    exportCSVValue,
    csvName,
    onSortChange,
    onSearchChange,
    onPageSizeChange,
    onFilterChange,
    defaultPageSize = 50,
    pageSizeOptions = [25, 50, 100, 200],
    extraColumns = [],
    updateColumnConditions = [],
    replaceContent = [],
    filterStatus,
    filterPractice,
    filterDivision,
    filterSmsDate,
    showClearbtn,
    showFilter,
    showTemplate,
    customFilterRole,
    customFilterActiveInActive,
    showSendBtn,
}) => {
    // console.log(
    //     "filterStatus:", filterStatus, "filterPractice:", filterPractice, "filterDivision:", filterDivision, "filterSmsDate:", filterSmsDate, "showClearbtn:", showClearbtn, "showFilter:", showFilter, "showTemplate:", showTemplate, "customFilterRole:", customFilterRole, "customFilterActiveInActive:", customFilterActiveInActive, "showSendBtn:", showSendBtn)
    const [pageIndex, setPageIndex] = useState(0);
    const exportCSV = exportCSVValue;
    const [pageSize, setPageSize] = useState(defaultPageSize);
    const [sortBy, setSortBy] = useState({ field: '', direction: '' });
    const [searchTerm, setSearchTerm] = useState('');
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [hoveredHeader, setHoveredHeader] = useState(null);
    const initialFilter = { roleFilter: '', statusFilter: '', practiceFilter: '', divisionFilter: '', smsStartFilter: '', smsEndFilter: '', activeInactiveFilter: "" }
    const [filterCondition, setFilterCondition] = useState(initialFilter);


    // Handle pagination
    const handlePageChange = (newPage) => {
        setPageIndex(newPage);
        onPageChange?.(newPage, pageSize);
    };

    // Handle sorting
    const handleSort = (field) => {
        const newSortBy = {
            field,
            direction: sortBy.field === field
                ? sortBy.direction === 'asc' ? 'desc' : ''
                : 'asc'
        };

        if (newSortBy.direction === '') {
            newSortBy.field = '';
        }

        setSortBy(newSortBy);
        onSortChange?.(newSortBy);
    };

    const handleExport = () => {
        const current = new Date();
        const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}, ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
        var wb = XLSX.utils.book_new();

        if (csvName == 'Inclinic') {
            data.forEach(
                function (v) {
                    delete v.callId; delete v.scheduledForUserId; delete v.userId; delete v.scheduledByUserId; delete v.practiceId; delete v.callingType; delete v.expertFullName; delete v.callNotesDisplay;
                });
        }

        if (csvName == 'User List') {
            data.forEach(function (v) { delete v.userId; delete v.goqiiUserId; delete v.encPatientId; delete v.userImageUrl; delete v.buttonDisplay; delete v.buttonName; delete v.encPatientIdWithType; delete v.subscriptionStartDate; delete v.subscriptionEndDate; });
        }


        var ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(wb, ws, `${csvName}`);
        XLSX.writeFile(wb, `${csvName} ${date}.csv`);
    }

    const handleClear = useCallback(() => {
        // Reset all filters to initial state
        setFilterCondition(initialFilter);

        // Reset other states
        setSearchTerm('');
        setSortBy({ field: '', direction: '' });
        setPageIndex(0);

        // Notify parent component of cleared filters
        onFilterChange?.(initialFilter);
        onSearchChange?.('');
        onSortChange?.({ field: '', direction: '' });
        onPageChange?.(0, pageSize);
    }, [onFilterChange, onSearchChange, onSortChange, onPageChange, pageSize]);


    const ExtrafilterComponent = useMemo(() => {
        setPageIndex(0);
        const filtertableData = (event) => {
            const tarname = event.target.name;
            setFilterCondition({ ...filterCondition, [tarname]: event.target.value })
            onFilterChange({ ...filterCondition, [tarname]: event.target.value });
        }

        const filtertableDataDate = (data) => {
            setFilterCondition({ ...filterCondition, ['smsStartFilter']: data[0].startDate, ['smsEndFilter']: data[0].endDate })
            onFilterChange({ ...filterCondition, ['smsStartFilter']: data[0].startDate, ['smsEndFilter']: data[0].endDate });
        }

        const updateTemplate = async (event) => {
            const tarname = event.target.name;
            const templateValue = event.target.value;
            setSelectedValue(templateValue);
        }

        const handleCheckboxChange = (checkboxName) => {
            setCheckedItems((prevCheckedItems) => ({
                ...prevCheckedItems,
                [checkboxName]: !prevCheckedItems[checkboxName],
            }));
        };
        const handleSearch = (value) => {
            setSearchTerm(value);
            if (debounceTimeout) {
                clearTimeout(debounceTimeout);
            }

            const timeout = setTimeout(() => {
                setPageIndex(0);
                onSearchChange?.(value);
            }, 500);

            setDebounceTimeout(timeout);
        };

        return (
            <>
                {showFilter && (
                    <div className="filter-container" key={data.length}>
                        <div className="filter-header">
                            <div className="header-content">
                                <h1 className="title">{title}</h1>
                                {console.log("totalRows", totalRows)}
                                <h4 className="total-count">Total: {totalRows}</h4>
                            </div>

                            <div className="filters-wrapper">
                                {filterStatus && (
                                    <div className="filter-item">
                                        <PatientStatusFilterComponent
                                            filterParam={filterCondition}
                                            onChange={filtertableData}
                                        />
                                    </div>
                                )}

                                {filterPractice && (
                                    <div className="filter-item">
                                        <PracticeFilterComponent
                                            filterParam={filterCondition}
                                            onChange={filtertableData}
                                        />
                                    </div>
                                )}

                                {filterDivision && (
                                    <div className="filter-item">
                                        <DivisionFilterComponent
                                            filterParam={filterCondition}
                                            onChange={filtertableData}
                                        />
                                    </div>
                                )}
                                {customFilterRole && (
                                    <div className="filter-item">
                                        <RoleFilterComponent
                                            filterParam={filterCondition}
                                            onChange={filtertableData}
                                        />
                                    </div>
                                )}

                                {customFilterActiveInActive && (
                                    <div className="filter-item">
                                        <ActiveInactiveFilterComponent
                                            filterParam={filterCondition}
                                            onChange={filtertableData}
                                        />
                                    </div>
                                )}

                                {showTemplate && (
                                    <div className="template-section">
                                        <WhatsAppCheck
                                            checkedItems={checkedItems}
                                            onChange={handleCheckboxChange}
                                        />
                                        <CommunicationChannel
                                            selectedValue={selectedValue}
                                            onChange={updateTemplate}
                                        />
                                    </div>
                                )}

                                {showSendBtn && (
                                    <div className="send-button-wrapper">
                                        <button
                                            type="button"
                                            className="send-button"
                                            onClick={() => sendReminder(selectedValue, checkedItems)}
                                        >
                                            Send Reminder to {data.length} Patients
                                        </button>
                                    </div>
                                )}

                                {/* <div className="search-export-wrapper"> */}
                                <div className="search-container">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="search-input"
                                        onChange={(e) => handleSearch(e.target.value)}
                                        value={searchTerm}
                                        autoFocus
                                    />
                                    <CircleX
                                        onClick={() => { setSearchTerm(''); handleSearch('') }}
                                        className="search-icon"
                                    />
                                </div>
                                {filterSmsDate && (
                                    <div className="filter-item">
                                        <SmsDateFilterComponent
                                            filterParam={filterCondition}
                                            onClick={filtertableDataDate}
                                        />
                                    </div>
                                )}
                                {exportCSV && (
                                    <button
                                        onClick={handleExport}
                                        className="export-csv-btn"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            padding: "8px 16px",
                                            border: "none",
                                            borderRadius: "8px",
                                            backgroundColor: "#4CAF50", // A green color for success/export
                                            color: "#ffffff",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                                        }}
                                        onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#388E3C")}
                                        onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#4CAF50")}
                                    >
                                        <Download size={20} />
                                        Export CSV
                                    </button>
                                )}
                                {showTemplate && (
                                    <div className="message-template">
                                        <MessageTemplate
                                            selectedValue={selectedValue}
                                            onChange={filtertableData}
                                        />
                                    </div>
                                )}
                                {showClearbtn && (
                                    <button
                                        onClick={handleClear}
                                        className="clear-filter-btn"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            padding: "8px 16px",
                                            border: "none",
                                            borderRadius: "8px",
                                            backgroundColor: "#f44336", // A soft red color
                                            color: "#ffffff",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                                        }}
                                        onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#d32f2f")}
                                        onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#f44336")}
                                    >
                                        <FilterX className="clear-icon" size={20} />
                                        Clear Filters
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }, [filterCondition.roleFilter, filterCondition.statusFilter, filterCondition.practiceFilter,
    filterCondition.divisionFilter, filterCondition.smsStartFilter, filterCondition.smsEndFilter, searchTerm, totalRows, showFilter, showTemplate, showClearbtn, showSendBtn, exportCSV, customFilterRole, customFilterActiveInActive]);


    // Handle page size change
    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
        setPageIndex(0);
        onPageSizeChange?.(newPageSize);
    };

    const totalPages = Math.ceil(totalRows / pageSize);

    // Helper function to render sort icon
    const renderSortIcon = (field) => {
        if (sortBy.field !== field) return null;

        return sortBy.direction === 'asc'
            ? <ChevronUp className="w-4 h-4 text-blue-600" />
            : <ChevronDown className="w-4 h-4 text-blue-600" />;
    };

    // Helper function to render cell content based on conditions and replacements
    const renderCellContent = (column, row) => {
        // Check for replaceContent first
        const replacement = replaceContent.find(r => r.col_name === column.field);
        if (replacement) {
            return replacement.content(row);
        }

        // Check for updateColumnConditions
        const condition = updateColumnConditions.find(cond => cond.condition(column, row));
        if (condition) {
            return condition.content(row);
        }
        // Default case
        return row[column.field];
    };


    // Filter out omitted extra columns
    const filteredExtraColumns = extraColumns.filter(col => !col.omit);

    return (
        <div className="w-full space-y-4">
            {ExtrafilterComponent}

            {/* Table */}
            <div className="table-container">
                <div className="table-scroll-container">
                    <table className="data-table">
                        <thead className="table-header">
                            <tr>
                                {[...columns, ...filteredExtraColumns].map((column, index) => (
                                    <th
                                        key={column.field}
                                        className={`table-header-cell ${index === 0 ? 'image-column' : ''}`}
                                        onClick={() => handleSort(column.field)}
                                        onMouseEnter={() => setHoveredHeader(index)}
                                        onMouseLeave={() => setHoveredHeader(null)}
                                    >
                                        <div className="header-content">
                                            <span className="header-text">{column.label}</span>
                                            <div className="sort-icon-container">
                                                {hoveredHeader === index && sortBy.direction === "" && sortBy.field === "" && (
                                                    <ChevronUp className="sort-icon" />
                                                )}
                                                {renderSortIcon(column.field)}
                                            </div>
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={columns.length + filteredExtraColumns.length} className="status-cell">
                                        <div className="loading-container">
                                            <div className="loading-spinner"></div>
                                            Loading...
                                        </div>
                                    </td>
                                </tr>
                            ) : data.length === 0 ? (
                                <tr>
                                    <td colSpan={columns.length + filteredExtraColumns.length} className="status-cell">
                                        No data found
                                    </td>
                                </tr>
                            ) : (
                                data.map((row, rowIndex) => (
                                    <tr key={rowIndex} className={`table-row ${rowIndex % 2 === 0 ? 'row-even' : 'row-odd'}`}>
                                        {columns.map((column, colIndex) => (
                                            <td key={column.field} className={`table-cell ${colIndex === 0 ? 'image-column' : ''}`}>
                                                {colIndex === 0 && row.image ? (
                                                    <div className="image-container">
                                                        <img
                                                            src={row.image}
                                                            alt={`${row.name || 'Item'}`}
                                                            className="cell-image"
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="cell-content">
                                                        {renderCellContent(column, row)}
                                                    </div>
                                                )}
                                            </td>
                                        ))}
                                        {filteredExtraColumns.map((column) => (
                                            <td key={column.field} className="table-cell">
                                                <div className="cell-content">
                                                    {column.content ? column.content(row) : row[column.field]}
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            <div className="pagination-container">
                <div className="pagination-controls">
                    <select
                        value={pageSize}
                        onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                        className="page-size-select"
                    >
                        {pageSizeOptions.map((size) => (
                            <option key={size} value={size}>
                                {size} rows
                            </option>
                        ))}
                    </select>
                    <span className="pagination-info">
                        Showing {totalRows ? pageIndex * pageSize + 1 : 0} to{' '}
                        {Math.min((pageIndex + 1) * pageSize, totalRows)} of {totalRows} entries
                    </span>
                </div>

                <div className="pagination-buttons">
                    <button
                        onClick={() => handlePageChange(0)}
                        disabled={pageIndex === 0}
                        className="pagination-button"
                        aria-label="First page"
                    >
                        <ChevronsLeft className="pagination-icon" />
                    </button>
                    <button
                        onClick={() => handlePageChange(pageIndex - 1)}
                        disabled={pageIndex === 0}
                        className="pagination-button"
                        aria-label="Previous page"
                    >
                        <ChevronLeft className="pagination-icon" />
                    </button>
                    <span className="pagination-info">
                        Page {pageIndex + 1} of {totalPages}
                    </span>
                    <button
                        onClick={() => handlePageChange(pageIndex + 1)}
                        disabled={pageIndex >= totalPages - 1}
                        className="pagination-button"
                        aria-label="Next page"
                    >
                        <ChevronRight className="pagination-icon" />
                    </button>
                    <button
                        onClick={() => handlePageChange(totalPages - 1)}
                        disabled={pageIndex >= totalPages - 1}
                        className="pagination-button"
                        aria-label="Last page"
                    >
                        <ChevronsRight className="pagination-icon" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DataTable;